import React from "react";
import SimpleBanner from "../../components/common/Banner";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchBlogs = () => {
    let data = "";

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/blogs/all-blogs`,
      headers: {},
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setBlogs(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setError("Failed to fetch blogs");
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const truncateContent = (content, maxLength = 100) => {
    if (content.length <= maxLength) return content;
    return content.substring(0, maxLength) + "...";
  };

  const SkeletonCard = () => (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden animate-pulse">
      <div className="w-full h-48 bg-gray-300"></div>

      <div className="p-4">
        <div className="flex justify-between items-center mb-2">
          <div className="h-3 bg-gray-300 rounded w-24"></div>
          <div className="h-3 bg-gray-300 rounded w-16"></div>
        </div>

        <div className="space-y-2 mb-2">
          <div className="h-4 bg-gray-300 rounded w-full"></div>
          <div className="h-4 bg-gray-300 rounded w-3/4"></div>
        </div>

        <div className="space-y-2 mb-3">
          <div className="h-3 bg-gray-300 rounded w-full"></div>
          <div className="h-3 bg-gray-300 rounded w-full"></div>
          <div className="h-3 bg-gray-300 rounded w-2/3"></div>
        </div>

        <div className="flex gap-2 mb-3">
          <div className="h-6 bg-gray-300 rounded-full w-16"></div>
          <div className="h-6 bg-gray-300 rounded-full w-20"></div>
        </div>

        <div className="h-4 bg-gray-300 rounded w-24"></div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <>
        <SimpleBanner name_primary="Our" name_secondary="Blog" />
        <div className="mt-5 px-4 sm:px-8 md:px-12 lg:px-20 py-10">
          <div className="flex flex-col justify-center items-center text-center">
            <h1 className="text-[#FF5E14] text-4xl font-semibold tracking-wider">
              Latest <span className="text-black">Blogs</span>
            </h1>
            <div className="mt-5 max-w-3xl">
              <p className="text-gray-500 text-lg/[30px] leading-relaxed tracking-wider text-center">
                Stay updated with our latest insights on real estate, investment
                opportunities, and market trends. Discover valuable information
                to help you make informed decisions.
              </p>
            </div>
          </div>

          <div className="mt-10">
            <div className="mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {Array.from({ length: 8 }).map((_, index) => (
                <SkeletonCard key={index} />
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <SimpleBanner name_primary="Our" name_secondary="Blog" />
        <div className="mt-5 px-4 sm:px-8 md:px-12 lg:px-20 py-10">
          <div className="flex justify-center items-center">
            <p className="text-lg text-red-500">{error}</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="overflow-hidden">
      <SimpleBanner name_primary="Our" name_secondary="Blog" />
      <div className="mt-5 px-4 sm:px-8 md:px-12 lg:px-20 py-10">
        <div className="flex flex-col justify-center items-center text-center">
          <h1 className="text-[#FF5E14] text-4xl font-semibold tracking-wider">
            Latest <span className="text-black">Blogs</span>
          </h1>
          <div className="mt-5 max-w-3xl">
            <p className="text-gray-500 text-lg/[30px] leading-relaxed tracking-wider text-center">
              Stay updated with our latest insights on real estate, investment
              opportunities, and market trends. Discover valuable information to
              help you make informed decisions.
            </p>
          </div>
        </div>

        <div className="mt-10">
          {blogs.length === 0 ? (
            <div className="flex justify-center items-center">
              <p className="text-lg text-gray-500">
                No blogs available at the moment.
              </p>
            </div>
          ) : (
            <div className="mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {blogs.map((blog) => (
                <div
                  key={blog._id}
                  className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden"
                >
                  <div className="relative">
                    <img
                      src={
                        blog.images && blog.images.length > 0
                          ? blog.images[0]
                          : "/placeholder-image.jpg"
                      }
                      alt={blog.title}
                      className="w-full h-48 object-cover"
                      onError={(e) => {
                        e.target.src = "/placeholder-image.jpg";
                      }}
                    />

                    <div className="absolute top-2 right-2">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-semibold ${
                          blog.status === "published"
                            ? "bg-green-100 text-green-800"
                            : "bg-yellow-100 text-yellow-800"
                        }`}
                      >
                        {blog.status}
                      </span>
                    </div>
                  </div>

                  <div className="p-4">
                    <div className="flex justify-between items-center mb-2">
                      <p className="text-gray-500 text-sm">
                        {formatDate(blog.publishedDate || blog.createdAt)}
                      </p>
                      <p className="text-gray-500 text-sm">By {blog.author}</p>
                    </div>

                    <h2 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
                      {blog.title}
                    </h2>

                    <p className="text-gray-600 text-sm mb-3 line-clamp-3">
                      {truncateContent(blog.content)}
                    </p>

                    {blog.tags && blog.tags.length > 0 && (
                      <div className="flex flex-wrap gap-1 mb-3">
                        {blog.tags.slice(0, 2).map((tag, index) => (
                          <span
                            key={index}
                            className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full"
                          >
                            {tag}
                          </span>
                        ))}
                        {blog.tags.length > 2 && (
                          <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                            +{blog.tags.length - 2} more
                          </span>
                        )}
                      </div>
                    )}

                    <div
                      className="text-[#FF5E14] font-semibold text-sm hover:underline flex items-center transition-colors duration-200 cursor-pointer"
                      onClick={() => {
                        navigate(`/blogs/blogDetails/${blog._id}`);
                      }}
                    >
                      READ MORE <span className="ml-1">→</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Blog;
